import * as React from "react";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
} from "../providers";

export const ReactCheckout2022BodyClasses: React.FunctionComponent = () => {
  const { currentRoute } = useReactCheckout2022Router();

  React.useEffect(() => {
    if (currentRoute === ReactCheckout2022Route.payment) {
      document.body.classList.add("react-checkout-2022--page-payment");
    }
    return () => {
      document.body.classList.remove("react-checkout-2022--page-payment");
    };
  }, [currentRoute]);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentRoute]);

  return null;
};
